/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Text } from 'react-native';
import '../date.css';
import styles from '../styles';

interface Props {
  label: string;
  required?: boolean;
  callBack?: any;
  defaultValue?: Date;
  requiredField?:boolean;
  isScolaire?:boolean;
  minAge?:number;
  maxAge?:number;
  isRetraite? : boolean;
  dateMax? : Date;
  dateMin? : Date;
  isDateContrat? : boolean;
}

interface Error {
  message: string;
  exist: boolean;
}
export default ({label, required, callBack, defaultValue, requiredField, isScolaire, minAge, maxAge, isRetraite, dateMax, dateMin, isDateContrat}: Props) => {
  const [startDate, setStartDate] = useState(defaultValue);
  const [IsFocus, setIsFocus] = useState(requiredField);
  const [error, setError] = useState<Error>({message: '', exist: false});
  const _minAge=minAge?minAge:18
  const _maxAge=maxAge?maxAge:60
  if (!startDate) {
    error.exist = true;
    error.message = 'Ce champ est obligatoire';
  }

  return (
    <div className={requiredField&&error.exist?'inputError':'datetimeCss'} >
      {label && (
        <label className={'datetimeLabel'}>
          {label} {required && <span>*</span>}:{' '}
        </label>
      )}
      <DatePicker
        dateFormat="dd/MM/yyyy"
        selected={startDate}
        maxDate = {dateMax}
        minDate = {dateMin}
        onChange={(date: any) => {
         
         setIsFocus(true);
          setStartDate(date);

          required=true;
          requiredField=true;
          const maxDate=new Date().setFullYear(new Date().getFullYear() - _minAge)
          const minDate=new Date().setFullYear(new Date().getFullYear() - _maxAge)
          if (!isDateContrat){
            if (!date) {
              error.exist = true;
              error.message = 'Ce champ est obligatoire';
              callBack('');
            }
            else if (isRetraite && date>=maxDate ){
              error.exist = true;
              error.message = `Vous devez être âgé d'au moins ${_minAge} ans`;
  
              callBack('');
            }
            else if( !isScolaire && date>=maxDate || date<minDate ){
              
              error.exist = true;
              error.message = `Vous devez être âgé entre ${_minAge} et ${_maxAge} ans`;
  
              callBack('');
            }
            else {
              error.exist = false;
              error.message = '';
              callBack(date);
            }
          } else {callBack(date);}
          
          
        }}
      />
      {requiredField && error.exist && <Text style={styles.textError}>{error.message}</Text>}
    </div>
  );
};
